import React from 'react';
import { Auth0Provider as Auth0ProviderSDK } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { getConfig } from '../config';
import { sessionStorage, STORAGE_KEYS } from '../utils/sessionStorage';

interface Auth0ProviderProps {
  children: React.ReactNode;
}

export const Auth0Provider: React.FC<Auth0ProviderProps> = ({ children }) => {
  const navigate = useNavigate();
  const config = getConfig();
  
  // Ensure auth0 config exists
  if (!config.auth0) {
    console.error('Auth0 configuration is missing');
    return <>{children}</>;
  }
  
  const { domain, clientId, callbackUrl, audience } = config.auth0;
  
  const onRedirectCallback = (appState: any) => {
    // If appState has returnTo, use it
    if (appState?.returnTo) {
      console.log('Auth0Provider: Redirecting to saved route:', appState.returnTo);
      navigate(appState.returnTo);
    } else {
      // Check session storage as fallback
      const savedRoute = sessionStorage.getItem<{pathname: string, state: any}>(STORAGE_KEYS.ROUTE);
      if (savedRoute) {
        console.log('Auth0Provider: Redirecting to saved route from session storage:', savedRoute.pathname);
        navigate(savedRoute.pathname, {
          state: savedRoute.state
        });
      } else {
        // Default to home if no saved route
        console.log('Auth0Provider: No saved route, navigating to home');
        navigate('/home');
      }
    }
  };
  
  return (
    <Auth0ProviderSDK
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: callbackUrl,
        audience: audience,
        scope: 'openid profile email'
      }}
      onRedirectCallback={onRedirectCallback}
      cacheLocation="localstorage"
      useRefreshTokens={true}
    >
      {children}
    </Auth0ProviderSDK>
  );
};

export default Auth0Provider;